<template>
    <div class="input-group | vn-input-password" :class="cssInputClass">

        <label :for="instanceId" v-html="field.title"></label>
        <input
            :name="key"
            :id="instanceId"
            type="password"
            v-model="value"
            @blur="clearError"
        />

        <span class="error-message" v-if="gotError"> {{ errorMessage }} </span>
    </div>
</template>

<script>

export default
{
    name: "InputPassword"
}

</script>

<script setup>

    import useFormInput       from "../../composables/useFormInput";
    import { onMounted, ref } from 'vue';
    import { uniqueId }       from 'lodash-es';

    let props = defineProps(["field"]);

    let { gotError, clearError, cssInputClass, errorMessage, value, key, exposed } = useFormInput(props);

    defineExpose(exposed)

    let instanceId = ref( null );

    onMounted(() => {
        if ( instanceId.value === null )
        {
            instanceId.value = uniqueId( props.field.key + '_' );
        }
    })

</script>
